import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import EvaluationTypeServices from "./EvaluationType.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getEvaluationType = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EVALUATION_TYPE,
      payload: true,
    });
    const resp = await EvaluationTypeServices.getEvaluationType(filters);
    dispatch({
      type: actions.GET_EVALUATION_TYPE,
      payload: {
        evaluationTypes: resp.data.data,
        evaluationTypesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.EVALUATION_TYPE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.EVALUATION_TYPE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EVALUATION_TYPE,
      payload: false,
    });
  }
};

export const getEvaluationTypeById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EVALUATION_TYPE_BY_ID,
      payload: true,
    });
    const resp = await EvaluationTypeServices.getEvaluationTypeById(id);
    dispatch({
      type: actions.GET_EVALUATION_TYPE_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.EVALUATION_TYPE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.EVALUATION_TYPE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EVALUATION_TYPE_BY_ID,
      payload: false,
    });
  }
};

export const saveEvaluationType = (data, setShowModal, setIsDisable) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_EVALUATION_TYPE,
      payload: true,
    });
    const resp = await EvaluationTypeServices.saveEvaluationType(data);
    const { evaluationTypes, evaluationTypesLength } = getState().evaluationType;
    const _evaluationTypes = [...evaluationTypes, resp.data];
    if(data.requerido){
      setIsDisable(true)
    }else{
      setIsDisable(false)
    }
    dispatch({
      type: actions.GET_EVALUATION_TYPE,
      payload: {
        evaluationTypes: _evaluationTypes,
        evaluationTypesLength: evaluationTypesLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_EVALUATION_TYPE,
      payload: false,
    });
  }
};

export const editEvaluationType = (data, id, index, setShowModal, setIsDisable) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EVALUATION_TYPE,
      payload: true,
    });
    const resp = await EvaluationTypeServices.editEvaluationType(id, data);
    const { evaluationTypes, evaluationTypesLength } = getState().evaluationType;
    evaluationTypes[index] = resp.data;
    if(data.requerido){
      setIsDisable(true)
    }else{
      setIsDisable(false)
    }
    dispatch({
      type: actions.GET_EVALUATION_TYPE,
      payload: {
        evaluationTypes: evaluationTypes,
        evaluationTypesLength: evaluationTypesLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EVALUATION_TYPE,
      payload: false,
    });
  }
};

export const editEvaluationTypeCheck = (data, id, index, setLoading) => async (dispatch, getState) => {
  try {
    setLoading(true);

    debugger
    const resp = await EvaluationTypeServices.editEvaluationType(id, data);
    const { evaluationTypes, evaluationTypesLength } = getState().evaluationType;
    evaluationTypes[index] = resp.data;
    dispatch({
      type: actions.GET_EVALUATION_TYPE,
      payload: {
        evaluationTypes: evaluationTypes,
        evaluationTypesLength: evaluationTypesLength,
      },
    });

    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    console.error(message)
  } finally {
    setLoading(false);
  }
};

export const deleteEvaluationType = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EVALUATION_TYPE,
      payload: true,
    });
    await EvaluationTypeServices.deleteEvaluationType(id);
    const { evaluationTypes, evaluationTypesLength } = getState().evaluationType;
    evaluationTypes.splice(index, 1);
    dispatch({
      type: actions.GET_EVALUATION_TYPE,
      payload: {
        evaluationTypes: evaluationTypes,
        evaluationTypesLength: evaluationTypesLength - 1,
      },
    });
    dispatch({
      type: actions.EVALUATION_TYPE_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.EVALUATION_TYPE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EVALUATION_TYPE,
      payload: false,
    });
  }
};
